import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-editable-label-input',
  template: `
    <div *ngIf="edit else label">
      <textarea *ngIf="textarea else input" class="form-control"
                [formControl]="control"
                (click)="preventClickPropagation($event)"
                (blur)="toggle($event)"
                #textAreaElement>
      </textarea>
      <ng-template #input>
        <input type="text" class="form-control"
               [formControl]="control"
               (click)="preventClickPropagation($event)"
               (blur)="toggle($event)"
               #inputElement>
      </ng-template>
    </div>

    <ng-template #label>
      <label [class]="labelClasses"
             [ngClass]="{'can-edit': canEdit ,'fst-italic': !control.value, 'ng-invalid': control.touched && control.invalid}"
             (click)="toggle($event)">
        {{ control.value || (placeholder | transloco) }}
      </label>
      <app-input-errors class="d-inline-block ms-3" [control]="control"></app-input-errors>
    </ng-template>
  `,
  styleUrls: ['./editable-label-input.component.scss']
})
export class EditableLabelInputComponent {
  protected readonly Validators = Validators;
  @Input() control = new FormControl<string>(null);
  @Input() placeholder = '';
  @Input() labelClasses = '';
  @Input() textarea = false;
  @Input() canEdit = true;


  @ViewChild('textAreaElement') textAreaElement: ElementRef;
  @ViewChild('inputElement') inputElement: ElementRef;
  edit = false;

  toggle(event: Event): void {
    if (!this.canEdit) {
      return;
    }

    this.edit = !this.edit;
    if (this.edit) {
      this.focus();
    }

    this.preventClickPropagation(event);
  }

  preventClickPropagation(event: Event): void {
    event.stopPropagation();
  }

  private focus(): void {
    setTimeout(() => {
      if (this.textarea) {
        this.textAreaElement?.nativeElement?.focus();
      } else {
        this.inputElement?.nativeElement?.focus();
      }
    });
  }
}
